import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { UserWalletComponent } from './user-wallet/user-wallet.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AppointmentListComponent } from './appointment-list/appointment-list.component';
import { AccountInfoComponent } from './account-info/account-info.component';
import { UserLayoutRoutes } from './user-layout.routing';
import { BrowserModule } from '@angular/platform-browser';
import { MessageComponent } from './message/message.component';
import { ChatComponent } from './chat/chat.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ToastModule } from 'primeng/toast';
import { TabViewModule } from 'primeng/tabview';
import { MessageService } from 'primeng/api';
import { PaginatorModule } from 'primeng/paginator';
import { FinancialRequestsComponent } from './financial-requests/financial-requests.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        RouterModule.forChild(UserLayoutRoutes),
        TranslateModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        TabViewModule,
        PaginatorModule,
        ToastModule
    ],
    declarations: [
        UserWalletComponent,
        // DashboardComponent,
        AppointmentListComponent,
        AccountInfoComponent,
        MessageComponent,
        ChatComponent,
        FinancialRequestsComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    providers: [
        MessageService
    ]
})

export class UserLayoutModule { }
